import React from 'react';
import {IndexRedirect, Route} from 'react-router';
import InboxPage from 'components/inbox/InboxPage';
import InboxItemList from 'components/inbox/page-content/InboxItemList';
import ViewTrendCalls from 'components/inbox/page-content/ViewTrendCalls';
import InboxCallCardPage from 'components/calls/InboxCallCardPage';

export const inboxRoute = (
  <>
    <Route path="inbox" component={InboxPage}>
      <IndexRedirect to="items" />
      <Route path="items" component={InboxItemList} />
      <Route path="trends/:ruleId/calls" component={ViewTrendCalls} />
    </Route>

    {/* Special call card with inbox features*/}
    {/* Note: This is out of the inbox parent, because we don't want the sidebar */}
    <Route path="fullscreen/items/:itemId/calls/:callId" component={InboxCallCardPage} />
  </>
);
